import { Component, OnInit, HostListener } from '@angular/core';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule, NgClass } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginPageComponent } from '../../pages/login-page/login-page.component';
import { Apiservice } from 'src/app/services/apiservice';
import Swal from 'sweetalert2';
@Component({
    selector: 'app-header-style-one',
    standalone: true,
    imports: [RouterLinkActive, NgClass, RouterLink, LoginPageComponent, CommonModule],
    templateUrl: './header-style-one.component.html',
    styleUrls: ['./header-style-one.component.scss']
})
export class HeaderStyleOneComponent implements OnInit {
    isSticky: boolean = false;
    showloader: boolean;
    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    isToggled = false;
    userData: any = null;
    constructor(public themeService: ThemeCustomizerService, private modalService: NgbModal, private api: Apiservice, private router: Router) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void {
        this.api.getUserData().subscribe((res: any) => {
            console.log(res);
            this.userData = res;

        })
    }

    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    classApplied2 = false;
    toggleClass2() {
        this.classApplied2 = !this.classApplied2;
    }

    classApplied3 = false;
    toggleClass3() {
        this.classApplied3 = !this.classApplied3;
    }
    openPopupview(popupname, num, i) {
        this.modalService.open(popupname, { centered: true, size: 'l', backdrop: false })
    }
    modalDismiss() {
        this.modalService.dismissAll();
    }

    navigteApplyForm() {
        let access_token = localStorage.getItem('access_token');
        if (access_token) {
            this.showloader = true;
            this.api.getUserprofileData().subscribe((res: any) => {
                console.log(res);
                this.showloader = false;
                if (res.status == 200) {
                    let user = res.data[0];
                    if (user.registration_status != 0) {
                        this.router.navigateByUrl('/profile');
                    } else {
                        Swal.fire({
                            title: 'Incomplete Registration',
                            text: 'You must complete your registration before viewing your profile. Do you want to complete it now?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Yes, complete now',
                            cancelButtonText: 'No, later',
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.router.navigateByUrl('/registration');
                            } else {
                                console.log('User chose not to register now.');
                            }
                        });


                    }

                }
            }, err => {
                this.showloader = false;
            })
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Login Required',
                text: 'Please login to continue.',
                confirmButtonText: 'OK'
            });
        }
        // 
    }

    logout() {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will be logged out of the session.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, logout',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                // 👉 Add your logout logic here
                // For example:
                localStorage.clear();
                sessionStorage.clear();
                // Navigate to login page
                this.router.navigate(['/'], { replaceUrl: true });

                Swal.fire({
                    title: 'Logged out',
                    text: 'You have been logged out successfully.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                location.reload();
            }
        });
    }
}